export interface ConversationFilters {
  isAnonymous: boolean;
  isOpen: boolean;
}

// This array of strings allows us to type-check at dev-time and at run-time,
// using a helper method in the component. The `type InboxView` two lines down
// is a string union infererred from this array of strings. cf.
// https://dev.to/hansott/how-to-check-if-string-is-member-of-union-type-1j4m
export const inboxViewsOptions = ['none', 'closed', 'anonymous'] as const;
type InboxViewTuple = typeof inboxViewsOptions;
export type InboxView = InboxViewTuple[number];
